import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import './EVs.scss';

const EVs = ({ language }) => {
  useEffect(() => {
    document.title = `${process.env.REACT_APP_PAGES_VEHICLES_TITLE} - Austin Energy EV Buyers Guide`;
  });

  return (
    <div className="vehicles-catalog-container">
      <zr-vehicles-catalog-widget
        lang={language.toLowerCase() ?? 'en'}
      ></zr-vehicles-catalog-widget>
    </div>
  );
};

export default EVs;

EVs.propTypes = {
  language: PropTypes.string.isRequired,
};
